import store from '@/store'

const isMobile = store.getters['source/isMobile']

export const color = isMobile ? '#333' : '#FFF'
export const background = isMobile ? '#FFF' : '#141414'

export default {
    '--background': background,
    '--color': color
}
